<h2 class="text-center"> Student List</h2>
<div class="table-responsive" *ngIf="!loading">
  <table datatable  [dtOptions]="dtOptions" class="row-border hover table table-striped display compact">
    <thead>
    <tr>
    <td></td>
    <td>Date Created</td>
    <th>Names</th>
    <th>Dashboard</th>
    <th>Class</th>
    <th>Details</th>
    <th> Manage</th>
    <th> Report</th>
    </tr>
    </thead>

    <tbody>

    <tr *ngFor="let student of students;">
        <td>{{student.server_student_id}}</td>
        <td>{{student.dateCreated}}</td>
        <td>{{student.fullname}}</td>
        <td>
            <a [routerLink]="['/student/show',student.server_user_id]" > <i class="fa fa-dashboard"></i></a>
        </td>
        <td>
            {{student.level_name}}
        </td>
        <td>
            <a [routerLink]="['/student/show',student.server_user_id]" ><i class="fa fa-eye"></i></a>
        </td>
        <td>
            <a [routerLink]="['/admin/student/manage',student.server_user_id]" ><i class="fa fa-cog"></i></a>
        </td>
        <td>
            <a [routerLink]="['/report/student/admin',student.server_user_id]" ><i class="fa fa-th"></i></a>


        </td>
    </tr>
    </tbody>

</table>
</div>
<app-empty [isEmpty]="isEmpty"></app-empty>
<app-loading [loading]="loading"></app-loading>

